// Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start

import { memo } from 'react';
import { Spinner, Row, Col } from 'react-bootstrap';

const BzLoader = ({ spinner, spinnerContent, bIsFfromModal=false, ...props }) => {
    return (
        spinner &&
        <div className='dataspinner-border'>
            <Row className='g-0 justify-content-center'>
                <Col>
                    <div className='text-center mb-3'>
                        <Spinner className='spinner-border color-text' animation="border" />
                    </div>
                    <div className={`font-regular font-size${bIsFfromModal?6:12} color-text`}>{spinnerContent}</div>
                </Col>
            </Row>           
        </div>
    );
};
export default memo(BzLoader);
    // Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End

